export class MailDuplicateParams {
  destinatairesUsers?: string;
  destinatairesServiceIds?: string;
  liens?: {
    linkCourrierId: number;
    typeLiaison?: string;
  };
  fileIds?: string;
  files?: string[];
  mailUniqueId?: string;
  serviceProprietaireId?: number;
  typeEntrantSortant?: string;
  confidentiel?: boolean;
  natureId?: number;
  sourceId?: number;
  refExpediteur?: string;
  expediteurLibre?: string;
  expediteurIdiAdmin?: number;
  expediteurId?: number;
  objet?: string;
  remarques?: string;
  dateDocument?: string;
  dateEcheance?: string;
  dateEntree?: string;
  classementId?: number;
  chemiseId?: number;
  classeurId?: number;
  referenceRecommande?: string;
  datePostale?: string;
  boiteArchive?: string;
  statutId?: number;
  annexeNonScannee?: boolean;
  annexeNonScanneeNombre?: number;
  annexeDiffusee?: boolean;
  centreNumerisationId?: number;
  natureCustomDatas?;
  createMethod?: string;
}
